import { Case } from "@/types/workflow";
import { WorkflowDisplay } from "./WorkflowDisplay";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

interface WorkflowSectionProps {
  selectedCase: Case;
  onWorkflowUpdate: () => void;
  onBack: () => void;
}

export function WorkflowSection({ 
  selectedCase, 
  onWorkflowUpdate,
  onBack 
}: WorkflowSectionProps) {
  const isMobile = useIsMobile();

  if (!selectedCase) {
    console.log("No case selected in WorkflowSection");
    return null;
  }

  const workflow = Array.isArray(selectedCase.workflow) ? selectedCase.workflow : [];

  return (
    <div className="h-[100dvh] max-h-[100dvh] flex flex-col bg-background">
      <div className={cn(
        "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4",
        "shrink-0 p-4 border-b",
        isMobile && "p-2 gap-2"
      )}>
        <Button
          variant="outline"
          size={isMobile ? "sm" : "default"}
          onClick={onBack}
          className={cn(
            "flex items-center gap-2",
            isMobile ? "w-auto text-sm" : "w-full sm:w-auto"
          )}
        >
          <ArrowLeft className={cn(
            "h-4 w-4",
            isMobile && "h-3 w-3"
          )} /> 
          Tilbake til saker
        </Button>
        <div className={cn(
          "text-lg font-semibold truncate max-w-full",
          isMobile && "text-base"
        )}>
          {selectedCase.title}
        </div>
      </div>

      <div className="flex-1 min-h-0 overflow-hidden">
        <WorkflowDisplay
          caseId={selectedCase.id}
          workflow={workflow}
          onWorkflowUpdate={onWorkflowUpdate}
        />
      </div>
    </div>
  );
}